import React, { ReactElement, useEffect, useState } from 'react';
import { Button, message, Pagination, Modal, Select, Spin } from 'antd';
import Masonry from 'react-masonry-css';
import { havePermission, IMyProjects, IUser } from '../../Competition';
import { IdeaCard } from '../../../../CardView/ProjectCard';
import { deleteReq, get, post } from '../../../../../libs/utils/request';
import { Loading } from '../../../../common/Loading';
import '../../Competition.css';
import AutoSearchInput from '../../../../common/AutoSearchInput';
import ViewSelector from '../ViewSelector';
import { ITheme } from '../../../../CardView/components/Themes';
import ConfirmationDialog from '../../../../common/ConfirmationDialog';
import SubmitProjectModal from '../SubmitProjectModal';
import SortSelector, { ISorter } from '../SortSelector';
import MobileList from './components/MobileList';
import { ICommentGroup } from '../../../../comments/Comments';

const { Option } = Select;

const styles = {
  root: {
    maxWidth: 1200,
    marginRight: 'auto',
    marginLeft: 'auto',
    marginTop: 74,
  },
  titleContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row' as const,
    justifyContent: 'space-between',
    flexWrap: 'wrap' as const,
    gap: '16px 16px',
  },
  title: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontSize: 30,
    fontWeight: 900,
    color: '#000',
  },
  selectorContainer: {
    marginTop: 10,
    width: '100%',
    display: 'flex',
    flexDirection: 'row-reverse' as const,
    gap: '0 10px',
  },
  paginationContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row' as const,
    justifyContent: 'center',
  },
  errorText: {
    fontSize: 20,
    marginTop: 72,
    textAlign: 'center' as const,
    fontWeight: 600,
    color: '#F00',
  },
  errorButtonText: {
    fontSize: 16,
    marginTop: 10,
    textAlign: 'center' as const,
    fontWeight: 400,
    textDecoration: 'underline',
    cursor: 'pointer',
    color: '#6755CE',
  },
  noResultText: {
    fontSize: 20,
    fontWeight: 'bold' as const,
    textAlign: 'center' as const,
    marginTop: 72,
    color: '#282828',
  },
  submitBtn: { fontWeight: 'bold' as const, minWidth: 150, marginTop: 80 },
};

const SORTERS: ISorter[] = [
  { value: 'shortlisted_A', text: 'Shortlisted (yes)' },
  { value: 'notShortlisted_A', text: 'Shortlisted (no)' },
  { value: 'name_A', text: 'Name (A to Z)' },
  { value: 'name_D', text: 'Name (Z to A)' },
  { value: 'team_A', text: 'Team (smallest)' },
  { value: 'team_D', text: 'Team (largest)' },
  { value: 'evaluation_A', text: 'Evaluation (lowest)' },
  { value: 'evaluation_D', text: 'Evaluation (highest)' },
  { value: 'registration date_A', text: 'Registration date (earlier)' },
  { value: 'registration date_D', text: 'Registration date (later)' },
];

const getSortParams = (value: string) => {
  const r = value.split('_');
  if (r.length === 2) {
    return { sort: r[0], order: r[1] === 'A' ? 'ASC' : 'DESC' };
  }
  return {};
};

const Ideas = ({
  tag, userRoles, myProjects, isTeamMember, onChange, evaluationStatus,
}: Props) => {
  const [isLoading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [ideas, setIdeas] = useState([]);
  const [ideaList, setIdeaList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [search, setSearch] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isListView, setListView] = useState(havePermission(['Organizer', 'Co-organizer'], userRoles));
  const [listLoading, setListLoading] = useState(false);
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const [submitModalVisible, setSubmitModalVisible] = useState(false);
  const [ideaModal, setIdeaModal] = useState(false);
  const [sortBy, setSortBy] = useState('registration date_D');
  const [participant,setParticipant] = useState(false)
  const [selectedIdea, setSelectedIdea] = useState(null);
  const [fetching, setFetching] = useState(false);
  const [searchIdeas, setSearchIdeas] = useState([]);
  const [allideas, setAllIdeas] = useState([]);

  let lastFetchId = 0;
  useEffect(() => {
    get<IIdea[]>(`/ideas/list?page=1&count=1000`).then((response) => { setAllIdeas(response); console.log(`idea list received with ${response.length} records.`); });
  }, []);

  const getAllIdeas = async (e: any) => {
    lastFetchId += 1;
    if (e.length < 3) {
      setSearchIdeas([]);
      setFetching(false);
      return;
    }
    const fetchId = lastFetchId;
    setSearchIdeas([]);
    setFetching(true);
    if (fetchId === lastFetchId) {
      //console.log(`1 project: ${JSON.stringify( allprojects[0] )}`);
      const filteredIdeas = allideas.filter(idea => JSON.stringify(idea).toLocaleLowerCase().includes(e.toLocaleLowerCase()))
      setSearchIdeas(
        filteredIdeas.map((u: any) => ({
          key: `${u.id}`,
          label: `${u.name} `,
          image: `${u.image}`,
          userid: `${u.owner.id}`
        }))
          //, () => { console.log(`Filtered: ${JSON.stringify(searchStartups[0])}`); })
      );
      setFetching(false);
    }
  };

  const addIdea = async () => {
    if (selectedIdea) {
      console.log(`Before addIdea: ${JSON.stringify( selectedIdea )}`);
      console.log(`Filtered: ${JSON.stringify(searchIdeas[0])}`);
      //const fullidearecord = searchIdeas.find(u => selectedIdea.label == u.label);
      //console.log(`record found for _${selectedIdea.label}_: ${JSON.stringify(fullidearecord)}`);
      //if (!fullidearecord) throw ""; 

      try {
        await post(`/competitions/${tag}/apply`, { id: selectedIdea.key, type: 'Idea' });
//        await post(`/competitions/${tag}/participants/${fullidearecord.userid}/accept`);
      } catch (error) {
        message.error(`Failed to submit idea. Error message: ${error.response?.data?.message}`);
      } 

      getIdeas();
    }
  };

  const [limit, setLimit] = useState(100);
  useEffect(() => {
    (async () => {
      const roles:any=await get(`competitions/${tag}/my-roles`)
      setParticipant(roles.isTeamMember)
      
      setErrorMessage('');
      setLoading(true);
      try {
        let pagination;
        const params: any = {
          currentPage,
          limit,
          ...(isListView ? getSortParams(sortBy) : {}),
        };
        if (search) {
          params.search = search;
        }
        if (isListView) {
          const tmp = await get<{ data: IIdeaListData[], pagination: any }>(`competitions/${tag}/ideas/listview`, params);
          // console.log(JSON.stringify(tmp, null, 2));
          setIdeaList(tmp.data);
          setIdeas([]);
          pagination = tmp.pagination;
        } else {
          const tmp = await get<any>(`competitions/${tag}/ideas`, params);
          // console.log(JSON.stringify(tmp, null, 2));
          if (tmp.data) {
            setIdeas(tmp.data.map((item: any) => ({
              ...item.idea,
              userRating: item.userRating ? item.userRating.rating : 0,
              interestGroups: item.idea.interests
                .map((int: any) => ({ id: int.id, name: int.name, icon: int.group.icon })),
            })));
          } else {
            setIdeas([]);
          }
          setIdeaList([]);
          pagination = tmp.pagination;
        }
        setTotalCount(pagination.totalCount);
        if (currentPage !== pagination.currentPage) {
          setCurrentPage(pagination.currentPage);
        }
        if (limit !== pagination.limit) {
          setLimit(pagination.limit);
        }
      } catch (error) {
        if (error.response?.data?.message) {
          setErrorMessage(error.response.data.message);
        } else {
          setErrorMessage(error.message);
        }
      } finally {
        setLoading(false);
      }
    })();
  }, [currentPage, isListView, limit, search, sortBy, tag]);

  const getIdeas = async (withLoading = true) => {
    setErrorMessage('');
    if (withLoading) {
      setLoading(true);
    }
    try {
      let pagination;
      const params: any = {
        currentPage,
        limit,
        ...(isListView ? getSortParams(sortBy) : {}),
      };
      if (search) {
        params.search = search;
      }
      if (isListView) {
        const tmp = await get<{ data: IIdeaListData[], pagination: any }>(`competitions/${tag}/ideas/listview`, params);
        // console.log(JSON.stringify(tmp, null, 2));
        setIdeaList(tmp.data);
        setIdeas([]);
        pagination = tmp.pagination;
      } else {
        const tmp = await get<any>(`competitions/${tag}/ideas`, params);
        // console.log(JSON.stringify(tmp, null, 2));
        if (tmp.data) {
          setIdeas(tmp.data.map((item: any) => ({
            ...item.idea,
            userRating: item.userRating ? item.userRating.rating : 0,
            interestGroups: item.idea.interests
              .map((int: any) => ({ id: int.id, name: int.name, icon: int.group.icon })),
          })));
        } else {
          setIdeas([]);
        }
        setIdeaList([]);
        pagination = tmp.pagination;
      }
      setTotalCount(pagination.totalCount);
      if (currentPage !== pagination.currentPage) {
        setCurrentPage(pagination.currentPage);
      }
      if (limit !== pagination.limit) {
        setLimit(pagination.limit);
      }
    } catch (error) {
      if (error.response?.data?.message) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage(error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const listIsEmpty = (): boolean => (isListView ? !ideaList.length : !ideas.length);

  const setNewIdea = (value: any) => {
    setSelectedIdea(value);
  };

  const handleDelete = async () => {
    try {
      setListLoading(true);
      await deleteReq(`/competitions/${tag}/ideas/${deleteId}`);
      await getIdeas(false);
    } catch (error) {
      message.error('Failed to delete idea.');
    } finally {
      setListLoading(false);
    }
  };

  const handleShortList = async (id: string, shortlist: boolean) => {
    try {
      setListLoading(true);
      await post(`/competitions/${tag}/ideas/${id}/shortlist`, { shortlist });
      await getIdeas(false);
    } catch (error) {
      message.error('Failed to shortlist idea.');
    } finally {
      setListLoading(false);
    }
  };

  const renderPaginationButtons = (marginTop = 0) => (
    <div style={{ ...styles.paginationContainer, marginTop }}>
      <Pagination
        current={currentPage}
        defaultPageSize={40}
        pageSize={limit}
        onChange={setCurrentPage}
        total={totalCount}
        style={{ marginTop }}
      />
    </div>
  );

  const renderWithPager = (content: ReactElement) => (
    <>
      {renderPaginationButtons(16)}
      {isLoading ? <Loading /> : content}
      {renderPaginationButtons(42)}
    </>
  );

  const renderPagination = () => {
    if (errorMessage) {
      return (
        <>
          <div style={styles.errorText}>Failed to load competitions:</div>
          <div style={{ ...styles.errorText, marginTop: 0, fontWeight: 400 }}>
            {errorMessage}
          </div>
          <div
            style={styles.errorButtonText}
            onClick={() => getIdeas()}
            aria-hidden='true'
          >
            retry
          </div>
        </>
      );
    }
    if (listIsEmpty() && !isLoading) {
      return <div style={styles.noResultText}>{`${search ? 'We didn\'t found anything.' : 'Nothing to show.'}`}</div>;
    }
    return renderWithPager(
      isListView ? (
        <MobileList
          listData={ideaList}
          onDelete={(id) => {
            setDeleteId(id);
            setDeleteDialogVisible(true);
          }}
          onShortlist={handleShortList}
          disabled={listLoading}
          evaluationStatus={evaluationStatus}
          style={{ marginTop: 48 }}
        />
      ) : (
        <Masonry
          breakpointCols={{ default: 2, 850: 1 }}
          className='startup-box-view'
          columnClassName='startup-box-view-item'
        >
          {ideas.map((idea: IIdea) => (
            <IdeaCard key={idea.id} idea={idea} onChange={() => getIdeas()} />
          ))}
        </Masonry>
      ),
    );
  };


  return (
    <div style={styles.root}>
      <div style={styles.titleContainer}>
        <div style={{ textAlign: 'center', paddingBottom: '60px', display: 'flex', justifyContent: 'space-between'}}>          <div style={styles.title}>{isListView ? 'Ideas' : 'Applied ideas'}</div>
          {participant ===false &&  !havePermission(['Organizer', 'Co-organizer'], userRoles) && (
            <Button style={styles.submitBtn} type='primary' size='large' onClick={() => setSubmitModalVisible(true)}>
              Submit idea
            </Button>
          )}
        <div style={{ width: '250px', textAlign: 'right'}}>
          { havePermission(['Organizer', 'Co-organizer'], userRoles) && (
            <Button style={styles.submitBtn} type='primary' size='large' onClick={() => setIdeaModal(true)}>
              Add Idea to Competition
            </Button>
          )}
        </div>        
      </div>        
        <div style={{ minWidth: 280 }}>
          <AutoSearchInput
            onSearch={(value) => {
              setSearch(value);
              setCurrentPage(1);
            }}
            style={{ width: '100%' }}
            placeholder='Type something...'
          />
          {havePermission(['Organizer', 'Co-organizer'], userRoles) && (
            <div style={styles.selectorContainer}>
              <ViewSelector isListView={isListView} onChange={setListView} />
              {isListView && (
                <SortSelector
                  value={sortBy}
                  onChange={setSortBy}
                  options={SORTERS}
                />
              )}
            </div>
          )}
        </div>
      </div>
      {renderPagination()}
      <ConfirmationDialog
        visible={deleteDialogVisible}
        onOk={() => {
          setDeleteDialogVisible(false);
          handleDelete();
        }}
        onCancel={() => setDeleteDialogVisible(false)}
        title='Delete idea'
        description='Are you sure you want to delete this idea? This operation is not revertible.'
        confirmBtnText='Delete'
        confirmBtnType='danger'
      />
      <SubmitProjectModal
        tag={tag}
        isStartup={false}
        visible={submitModalVisible}
        onSubmit={() => {
          setSubmitModalVisible(false);
          onChange();
        }}
        onCancel={() => setSubmitModalVisible(false)}
        myProjects={myProjects}
      />
      <Modal
        visible={ideaModal}
        onCancel={() => setIdeaModal(false)}
        onOk={() => {
          setIdeaModal(false);
          addIdea();
          // onWithdraw();
        }}
        title="Add Idea to Competition"
        destroyOnClose
      >
        <p>Add idea</p>
        <Select
          value={selectedIdea ? selectedIdea : ideas}
          showSearch
          labelInValue
          onChange={(value: any) => setNewIdea(value)}
          placeholder={`Select idea to add`}
          notFoundContent={fetching ? <Spin size="small" /> : null}
          optionFilterProp="children"
          filterOption={false}
          style={{ width: "100%" }}
          onSearch={(e: any) => getAllIdeas(e)}
        >
          {searchIdeas.map((u: any) => {
            return <Option key={u.key}>{u.label}</Option>;
          })}
        </Select>
      </Modal>
    </div>
  );
};

interface Props {
  tag: string;
  userRoles: string[];
  myProjects: IMyProjects;
  isTeamMember: boolean;
  onChange: () => void;
  evaluationStatus: 'INIT' | 'OPEN' | 'CLOSED';
}

export interface IIdea {
  organizer: any;
  uniqueTag: any;
  id: string;
  createdAt: string;
  name: string;
  details: string;
  image: string;
  averageRating?: number;
  ratingCount?: number;
  commentsCount?: number;
  user: IUser;
  userRating: number | any;
  interestGroups?: ITheme[];
  interests: any;
  pitchLink: string;
  additionalInfo?: string;
  commentable: boolean;
  shareCount: number;
  commentGroup: ICommentGroup;
  canJoin: boolean;
  canLeave: boolean;
  canWithdraw: boolean;
  ratingGroup: any
  owner?: any;
}

export interface IIdeaListData {
  membersCnt: number;
  id: string;
  isShortlisted: boolean;
  idea: IIdea;
  membersCount: number;
  score: number;
}

export default Ideas;
